import { render, staticRenderFns } from "./SchoolFinder-tj.vue?vue&type=template&id=45b52fc8&scoped=true&"
import script from "./SchoolFinder-tj.vue?vue&type=script&lang=js&"
export * from "./SchoolFinder-tj.vue?vue&type=script&lang=js&"
import style0 from "./SchoolFinder-tj.vue?vue&type=style&index=0&id=45b52fc8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b52fc8",
  null
  
)

export default component.exports